module.exports = __webpack_public_path__ + "img/tadzjaz-77f09852-a992-4e46-ce59-08d958505b99.png";